import React, {useState} from "react";

const cars = {
    name: 'Cars',
    id: 1,
    img: 'car.png',
    children: [
        {
            name: 'Suzuki',
            id: 2,
            img: 'suzuki.png',
            children: [
                {
                    name: 'Celerio',
                    id: 21,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 211,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Celerio LXI',
                                    id: 2111,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Celerio VXI',
                                    id: 2112,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Celerio ZXI',
                                    id: 2113,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Celerio AMT',
                                    id: 2114,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 212,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Celerio LXI',
                                    id: 2111,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Celerio VXI',
                                    id: 2112,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Celerio ZXI',
                                    id: 2113,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Celerio AMT',
                                    id: 2114,
                                    img: 'car2.png',
                                },
                            ]
                        },
                    ]
                },
                {
                    name: 'Swift',
                    id: 22,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 221,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Swift LXI',
                                    id: 2211,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Swift VXI',
                                    id: 2212,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Swift ZXI',
                                    id: 2213,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Swift AMT',
                                    id: 2214,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 222,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Swift LXI',
                                    id: 2221,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Swift VXI',
                                    id: 2222,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Swift ZXI',
                                    id: 2223,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Swift AMT',
                                    id: 2224,
                                    img: 'car2.png',
                                },
                            ]
                        },
                    ]
                },
                {
                    name: 'Baleno',
                    id: 23,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 231,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Baleno Sigma',
                                    id: 2311,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Baleno Delta',
                                    id: 2312,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Baleno Zeta',
                                    id: 2313,
                                    img: 'car2.png',
                                }
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 232,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Baleno Sigma',
                                    id: 2321,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Baleno Delta',
                                    id: 2322,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Baleno Zeta',
                                    id: 2323,
                                    img: 'car2.png',
                                }
                            ]
                        },
                    ]
                },
            ]
        },
        {
            name: 'Tata',
            id: 3,
            img: 'tata.png',
            children: [
                {
                    name: 'Altroz',
                    id: 31,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 311,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Altroz XE',
                                    id: 3111,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Altroz XM',
                                    id: 3112,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Altroz XT',
                                    id: 3113,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Diesel',
                            id: 312,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Altroz XE',
                                    id: 3121,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Altroz XM',
                                    id: 3122,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Altroz XT',
                                    id: 3123,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 313,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Altroz XE',
                                    id: 3131,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Altroz XM',
                                    id: 3132,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Altroz XT',
                                    id: 3133,
                                    img: 'car2.png',
                                },
                            ]
                        }
                    ]
                },
                {
                    name: 'Nexon',
                    id: 32,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 321,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Nexon XE',
                                    id: 3211,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nexon XM',
                                    id: 3212,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nexon XT',
                                    id: 3213,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Diesel',
                            id: 322,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Nexon XE',
                                    id: 3121,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nexon XM',
                                    id: 3122,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nexon XT',
                                    id: 3123,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 323,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Nexon XE',
                                    id: 3231,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nexon XM',
                                    id: 3232,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nexon XT',
                                    id: 3233,
                                    img: 'car2.png',
                                },
                            ]
                        }
                    ]
                },
                {
                    name: 'Punch',
                    id: 33,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 331,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Punch XE',
                                    id: 3311,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Altroz XM',
                                    id: 3312,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Punch XT',
                                    id: 3313,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Diesel',
                            id: 332,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Punch XE',
                                    id: 3321,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Punch XM',
                                    id: 3322,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Punch XT',
                                    id: 3323,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 333,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Punch XE',
                                    id: 3331,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Punch XM',
                                    id: 3332,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Punch XT',
                                    id: 3333,
                                    img: 'car2.png',
                                },
                            ]
                        }
                    ]
                },
            ]
        },
        {
            name: 'Hyundai',
            id: 4,
            img: 'hyundai.png',
            children: [
                {
                    name: 'i10 Nios',
                    id: 41,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 411,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Nios Magna',
                                    id: 4111,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nios Sportz',
                                    id: 4112,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nios Asta',
                                    id: 4113,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 412,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Nios Magna',
                                    id: 4121,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nios Sportz',
                                    id: 4122,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Nios Asta',
                                    id: 4123,
                                    img: 'car2.png',
                                },
                            ]
                        },
                    ]
                },
                {
                    name: 'i20',
                    id: 42,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 421,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'i20 Magna',
                                    id: 4211,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'i20 Sportz',
                                    id: 4212,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'i20 Asta',
                                    id: 4213,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 422,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'i20 Magna',
                                    id: 4221,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'i20 Sportz',
                                    id: 4222,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'i20 Asta',
                                    id: 4223,
                                    img: 'car2.png',
                                },
                            ]
                        },
                    ]
                },
                {
                    name: 'Verna',
                    id: 43,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 431,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Verna Magna',
                                    id: 4311,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Verna Sportz',
                                    id: 4312,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Verna Asta',
                                    id: 4313,
                                    img: 'car2.png',
                                },
                            ]
                        },
                        {
                            name: 'Cng',
                            id: 432,
                            img: 'gas.png',
                            children: [
                                {
                                    name: 'Verna Magna',
                                    id: 4321,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Verna Sportz',
                                    id: 4322,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Verna Asta',
                                    id: 4323,
                                    img: 'car2.png',
                                },
                            ]
                        },
                    ]
                },
            ]
        },
        {
            name: 'Honda',
            id: 5,
            img: 'honda.png',
            children: [
                {
                    name: 'Honda City',
                    id: 51,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 511,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'City SV',
                                    id: 5111,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'City V',
                                    id: 5112,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'City VX',
                                    id: 5113,
                                    img: 'car2.png',
                                },
                            ]
                        }
                    ]
                },
                {
                    name: 'Honda Amaze',
                    id: 52,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 521,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'Amaze E',
                                    id: 5211,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Amaze S',
                                    id: 5212,
                                    img: 'car2.png',
                                },
                                {
                                    name: 'Amaze VX',
                                    id: 5213,
                                    img: 'car2.png',
                                },
                            ]
                        }
                    ]
                },
                {
                    name: 'Honda Elevate',
                    id: 53,
                    img: 'car2.png',
                    children: [
                        {
                            name: 'Petrol',
                            id: 531,
                            img: 'oil.png',
                            children: [
                                {
                                    name: 'STD',
                                    id: 5311,
                                    img: 'car2.png',
                                }
                            ]
                        }
                    ]
                },
            ]
        },
    ]
}

const FlowContext = React.createContext({
    cars: {},
    centerObj: {},
    historyObj: [],
    animate: null,
    getDetails: () => {},
    goBack: () => {},
})

export const FlowContextProvider = (props) => {
    const [animate, setAnimate] = useState(true);
    const [centerObj, setCenterObj] = useState(cars);
    const [historyObj, setHistoryObj] = useState([]);

    const getDetails = (obj) => {
        if (('children' in obj) && obj.children.length > 0) {
            setAnimate(false);
            setHistoryObj(prevState => {
                return [...prevState, centerObj];
            });
            setCenterObj({...obj});
            setTimeout(() => {
                setAnimate(true);
            }, 100);
        }
    }

    const goBack = () => {
        if (historyObj.length > 0) {
            setAnimate(false);
            setCenterObj({...historyObj[historyObj.length - 1]});
            setHistoryObj(prevState => {
                const id = prevState[prevState.length - 1].id;
                const newHistoryObj = prevState.filter((obj) => obj.id !== id);
                return [...newHistoryObj];
            })
            setTimeout(() => {
                setAnimate(true)
            }, 100);
        }

    }
    return(
        <FlowContext.Provider value={{
            cars: cars,
            centerObj: centerObj,
            historyObj: historyObj,
            animate: animate,
            getDetails: getDetails,
            goBack: goBack
        }}>
            {props.children}
        </FlowContext.Provider>
    )
}

export default FlowContext;
